const Cookies = require('js-cookie');

export default class UnverifiedModal {

  constructor() {
    this.$modal = $('.vidio-modal');
    this.$closeModal = $('.vidio-modal__close');
    this.$overlayModal = $('.vidio-modal__overlay');
    this.cookieName = "unverified_user_modal";
  }

  show() {
    this.$modal.addClass('vidio-modal__show');
  }

  closeModal() {
    this.$modal.removeClass('vidio-modal__show');
  }

  setCookie() {
    Cookies.set(this.cookieName, 'true', { expires: 30 });
  }

  bindEvents() {
    this.$closeModal.click((event) => {
      event.preventDefault();
      this.closeModal();
    });

    this.$overlayModal.click((event) => {
      event.preventDefault();
      this.closeModal();
    });
  }

  init() {
    if(!Cookies.get(this.cookieName) && !$("body").hasClass("onboardings")) {
      this.show();
      this.bindEvents();
      this.setCookie();
    }
  }
}
